import React, { useEffect, useCallback, useState} from 'react';
import {RECORD, SAMPLE_PACK} from 'constants/release-types.js';
import {connect} from 'react-redux';

const ReleaseType = ({releaseType, setReleaseType}) => { 
    return (
        <div className="release-type-chooser">
          <div
            onClick={() => setReleaseType(RECORD)}
            className={releaseType === RECORD ? "option selected" : "option"}>
            Record
          </div>
          <div
            onClick={() => setReleaseType(SAMPLE_PACK)}
            className={releaseType === SAMPLE_PACK ? "option selected" : "option"}>
            Sample Pack
          </div>
          <div
            onClick={() => setReleaseType(undefined)}
            className={releaseType === undefined ? "option selected" : "option"}>
          None
        </div>
        </div>
    );
}

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ReleaseType);
